import { Dropdown } from "primereact/dropdown";
import React from "react";
import RMS_SECONDARY_MODIFIERS from "../../../mappings_dir/rms_secondary_modifiers.json";
import { Editor } from "./CellEditors";

type ModifierEntry = {
  label: string;
  edm_field: string;
  peril: string;
  options: Record<string, string>;
};

const MODIFIERS = RMS_SECONDARY_MODIFIERS as Record<string, ModifierEntry>;

export const hasModifierMapping = (field: string): boolean =>
  Object.prototype.hasOwnProperty.call(MODIFIERS, field);

export const formatModifierValue = (
  field: string,
  value: string | null | undefined
): string | undefined => {
  if (value == null || value === "") return undefined;
  const entry = MODIFIERS[field];
  const desc = entry?.options[value];
  return desc ? `${value} - ${desc}` : value;
};

type Option = { label: string; value: string };

const optionsCache: Record<string, Option[]> = {};

export const getModifierOptions = (field: string): Option[] => {
  if (optionsCache[field]) return optionsCache[field];
  const entry = MODIFIERS[field];
  const opts: Option[] = [{ label: "(none)", value: "" }];
  if (entry) {
    // Iterate in numeric code order so the dropdown is intuitive
    const codes = Object.keys(entry.options).sort(
      (a, b) => Number(a) - Number(b)
    );
    for (const code of codes) {
      opts.push({ label: `${code} - ${entry.options[code]}`, value: code });
    }
  }
  optionsCache[field] = opts;
  return opts;
};

export const makeModifierEditor = (field: string): Editor => {
  const options = getModifierOptions(field);
  const editor: Editor = ({
    options: { value, editorCallback },
    disabled,
    additionalStyles,
  }) =>
    React.createElement(Dropdown, {
      style: {
        width: "calc(100% - 0.5rem)",
        position: "inherit" as const,
        ...additionalStyles,
      },
      options,
      value: value ?? "",
      placeholder: "Select…",
      onChange: (e: { value: string }) => editorCallback?.(e.value),
      disabled,
      filter: options.length > 10,
    });
  return editor;
};
